export default __webpack_public_path__ + "static/media/Delivery.bf2f4847.svg";